import { __exports as web_domCollections_iterator } from './_virtual-web.dom-collections.iterator.js';
import { __require as requireGlobalThis } from './node_modules-core-js-internals-global-this.js';
import { __require as requireDomIterables } from './node_modules-core-js-internals-dom-iterables.js';
import { __require as requireDomTokenListPrototype } from './node_modules-core-js-internals-dom-token-list-prototype.js';
import { __require as requireEs_array_iterator } from './node_modules-core-js-modules-es.array.iterator.js';
import { __require as requireCreateNonEnumerableProperty } from './node_modules-core-js-internals-create-non-enumerable-property.js';
import { __require as requireSetToStringTag } from './node_modules-core-js-internals-set-to-string-tag.js';
import { __require as requireWellKnownSymbol } from './node_modules-core-js-internals-well-known-symbol.js';

var hasRequiredWeb_domCollections_iterator;

function requireWeb_domCollections_iterator () {
	if (hasRequiredWeb_domCollections_iterator) return web_domCollections_iterator;
	hasRequiredWeb_domCollections_iterator = 1;
	var globalThis = requireGlobalThis();
	var DOMIterables = requireDomIterables();
	var DOMTokenListPrototype = requireDomTokenListPrototype();
	var ArrayIteratorMethods = requireEs_array_iterator();
	var createNonEnumerableProperty = requireCreateNonEnumerableProperty();
	var setToStringTag = requireSetToStringTag();
	var wellKnownSymbol = requireWellKnownSymbol();

	var ITERATOR = wellKnownSymbol('iterator');
	var ArrayValues = ArrayIteratorMethods.values;

	var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
	  if (CollectionPrototype) {
	    // some Chrome versions have non-configurable methods on DOMTokenList
	    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
	      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
	    } catch (error) {
	      CollectionPrototype[ITERATOR] = ArrayValues;
	    }
	    setToStringTag(CollectionPrototype, COLLECTION_NAME, true);
	    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
	      // some Chrome versions have non-configurable methods on DOMTokenList
	      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
	        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
	      } catch (error) {
	        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
	      }
	    }
	  }
	};

	for (var COLLECTION_NAME in DOMIterables) {
	  handlePrototype(globalThis[COLLECTION_NAME] && globalThis[COLLECTION_NAME].prototype, COLLECTION_NAME);
	}

	handlePrototype(DOMTokenListPrototype, 'DOMTokenList');
	return web_domCollections_iterator;
}

export { requireWeb_domCollections_iterator as __require };
//# sourceMappingURL=node_modules-core-js-modules-web.dom-collections.iterator.js.map
